document.addEventListener('DOMContentLoaded', function () {
  async function loadShowsFromSheet() {
    const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQTZCqZGkKQ7yGCKM8G2oQRix5C6RsrdjXjZdU2ZGcrRRnvnYdb9oorKFo0kJU3sPpjFylWx7stbf08/pub?output=csv';
    const response = await fetch(csvUrl);
    const text = await response.text();

    const rows = text.split('\n').map(row => row.split(','));
    const headers = rows[0].map(h => h.trim().toLowerCase());
    const shows = rows.slice(1).filter(r => r.length >= headers.length).map(row => {
      let show = {};
      row.forEach((cell, idx) => {
        show[headers[idx]] = cell.trim();
      });
      return show;
    });

    const now = new Date(
      new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date()) + 'T00:00:00'
    );

    const upcoming = [];
    const previous = [];

    shows.forEach(show => {
      let [d, m, yRaw] = (show.date || '').split('-').map(Number);
      if (!d || !m || !yRaw) return;

      const y = yRaw < 100 ? yRaw + 2000 : yRaw;
      const actualDate = new Date(Date.UTC(y, m - 1, d));
      let flyerDate = new Date(actualDate);

      const startHour = parseInt((show.start_time || '0').split(':')[0], 10);
      if (startHour < 5) {
        flyerDate.setUTCDate(flyerDate.getUTCDate() - 1);
        show.is_late_night = true;
      }

      show.actual_date = actualDate;
      show.flyer_date = flyerDate;

      const flyerDateStr = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(flyerDate);

      show.timestamp = new Date(flyerDateStr + 'T00:00:00').getTime();

      if (show.timestamp >= now.getTime()) {
        upcoming.push(show);
      } else {
        previous.push(show);
      }
    });

    const container = document.getElementById('tourAgendaList');
    container.innerHTML = '';

    function renderSection(title, shows, isUpcoming = true) {
      if (!shows.length) return;

      const isUpcomingSection = title.toLowerCase().includes('upcoming');

      const heading = document.createElement('li');
      heading.className = 'tour-show-section-heading';
      heading.innerHTML = `
        <button class="accordion-toggle" data-section="${title}">
          ${title}
          <span class="accordion-icon">${isUpcomingSection ? '−' : '+'}</span>
        </button>
        <ul class="accordion-content${isUpcomingSection ? ' open' : ''}" id="section-${title.replace(/\s+/g, '-').toLowerCase()}"></ul>
      `;
      container.appendChild(heading);

      const sectionList = heading.querySelector('.accordion-content');
      if (!isUpcoming) sectionList.classList.add('accordion-preview');
      if (isUpcomingSection) sectionList.classList.add('open');

      shows.sort((a, b) => a.timestamp - b.timestamp);

      shows.forEach(show => {
        const li = document.createElement('li');
        li.className = 'tour-show';
        li.setAttribute('data-artist', show.artist || '');

        const displayDate = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Amsterdam',
          month: 'short',
          day: 'numeric'
        }).format(show.flyer_date);

        let realDateNote = '';
        if (show.is_late_night) {
          const weekday = date => new Intl.DateTimeFormat('en-US', {
            timeZone: 'Europe/Amsterdam',
            weekday: 'long'
          }).format(date);
          realDateNote = `🌙 ${weekday(show.flyer_date)} → ${weekday(show.actual_date)}`;
        }

        const start = show.start_time || '';
        const end = show.end_time || '';
        let durationText = '';
        if (start && end) {
          const [sh, sm] = start.split(':').map(Number);
          const [eh, em] = end.split(':').map(Number);
          const duration = (eh * 60 + em) - (sh * 60 + sm);
          if (duration > 0) durationText = ` (${duration} min)`;
        }

        let detailsHtml = '';
        if (isUpcoming && start && end) {
          detailsHtml += `<div class="tour-set-time">${start} – ${end}${durationText}</div>`;
        }
        detailsHtml += `<div class="tour-city">${show.city || ''}</div>`;
        if (isUpcoming) {
          detailsHtml += `<div class="tour-venue">${show.venue || ''}</div>`;
        }

        const isPrivate = (show.event_type || '').toLowerCase().includes('private');

        li.innerHTML = `
          <div class="tour-row">
            <div class="tour-date">
              ${displayDate}
              ${realDateNote ? `<br><span class="real-date">${realDateNote}</span>` : ''}
            </div>
            <div class="tour-details">
              ${show.show_name ? `<div class="tour-show-name">${show.show_name}</div>` : ''}
              <div class="tour-artist">${show.artist || ''}</div>
              ${detailsHtml}
            </div>
            ${
              isPrivate
                ? `<span class="private-event-label">Private Event</span>`
                : (show.link_url
                    ? `<a href="${show.link_url}" target="_blank" class="tour-link">${(show.link_type || 'TICKET').toUpperCase()}</a>`
                    : '')
            }
          </div>
        `;
        sectionList.appendChild(li);
      });
    }

    renderSection('Upcoming Shows', upcoming, true);
    renderSection('Previous Shows', previous, false);
    setupArtistFilter(shows);
  }

  function setupArtistFilter(shows) {
    const filter = document.getElementById('artistSelect');
    if (!filter) return;

    const artistSet = new Set();
    shows.forEach(s => {
      if (s.artist) artistSet.add(s.artist.trim());
    });

    const artists = Array.from(artistSet).sort();
    artists.forEach(artist => {
      const option = document.createElement('option');
      option.value = artist;
      option.textContent = artist;
      filter.appendChild(option);
    });

    filter.onchange = () => filterByArtist(filter.value);
  }

  function filterByArtist(artist) {
    const shows = document.querySelectorAll('.tour-show');
    let visibleCount = 0;

    shows.forEach(show => {
      const showArtist = show.getAttribute('data-artist');
      if (artist === 'all' || showArtist === artist) {
        show.style.display = '';
        visibleCount++;
      } else {
        show.style.display = 'none';
      }
    });

    document.getElementById('no-results').style.display = visibleCount === 0 ? 'block' : 'none';
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.accordion-toggle');
    if (!btn) return;

    const section = btn.nextElementSibling;
    const icon = btn.querySelector('.accordion-icon');
    const isOpen = section.classList.contains('open');

    section.classList.toggle('open');
    icon.textContent = isOpen ? '+' : '−';
  });

  loadShowsFromSheet();
});
